import React, { useCallback, useState } from 'react';

import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { Box, CircularProgress, LinearProgress, makeStyles, Typography } from '@material-ui/core';
import { Document, Page, pdfjs } from 'react-pdf';

import Toolbar from './Toolbar';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

const useStyles = makeStyles(() => ({
  loader: {
    alignItems: 'center',
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    height: '100%',
    justifyContent: 'center',
    padding: '16px',
    width: '100%',
  },
  loaderContainer: {
    alignItems: 'center',
    display: 'flex',
    height: '300px',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '300px',
  },
  pageLoader: {
    alignItems: 'center',
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    height: '100%',
    justifyContent: 'center',
    minHeight: '200px',
    minWidth: '200px',
  },
  pdfDocument: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    justifyContent: 'center',
    marginTop: '16px',
  },
  pdfPage: {
    backgroundColor: 'transparent !important',
    minHeight: '300px',
  },
  typographyTitle: {
    fontWeight: 'bold',
    padding: '8px',
  },
}));

const PdfViewer = ({ url, dimensions, title, hideToolbar }) => {
  const [pagesTotal, setPagesTotal] = useState(null);
  const [scale, setscale] = useState(1);
  const classes = useStyles();

  const onDocumentLoadSuccess = (data) => {
    setPagesTotal(data.numPages);
  };

  const handleZoomIn = () => setscale(scale * 1.1);
  const handleZoomOut = () => setscale(scale / 1.1);

  const loadingState = useCallback(
    (message = 'Loading file...', isLoading = true) => (
      <div className={classes.loaderContainer}>
        <div className={classes.loader}>
          {message}
          {isLoading && (
            <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box>
          )}
        </div>
      </div>
    ),
    [classes]
  );

  return (
    <div style={{ ...dimensions }}>
      {!hideToolbar ? <Toolbar scale={scale} onZoomIn={handleZoomIn} onZoomOut={handleZoomOut} /> : null}
      <Document
        className={classes.pdfDocument}
        file={url}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={loadingState()}
        error={loadingState('Error loading file', false)}
        noData={loadingState('No data found', false)}>
        {!!title && <Typography className={classes.typographyTitle}>{decodeURIComponent(title)}</Typography>}
        {Array.from(new Array(pagesTotal), (el, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            scale={scale}
            renderAnnotationLayer={false}
            renderTextLayer={false}
            loading={
              <div className={classes.pageLoader}>
                <CircularProgress size={40} />
              </div>
            }
          />
        ))}
      </Document>
    </div>
  );
};

export default PdfViewer;
